module.exports = __webpack_public_path__ + "img/motorcycle-crossing.0734d98b.jpg";